// extracted by mini-css-extract-plugin
export default {"root":"SuperNinjaTooltip_root__S4E-C","title":"SuperNinjaTooltip_title__0XHzC","description":"SuperNinjaTooltip_description__j5CLT","newLabel":"SuperNinjaTooltip_newLabel__SQ45+"};